import { Navigate, useLocation } from "react-router-dom";
import clsx from "clsx";
import Logo from "@/assets/img/raro_digital_black.svg?react";
import { useAuth } from "@/contexts/AuthContext";
import { LoadingSpinner } from "@/components/LoadingSpinner";
import { Button } from "@/components/Button";
import { Alert } from "@/components/Alert";
import {
  getContainerClasses,
  getCardClasses,
  MICROSOFT_ICON_PATH,
  LOGIN_MESSAGES,
} from "./login.definitions";

export default function Login() {
  const location = useLocation();
  const {
    user,
    loading,
    signInWithMicrosoft,
    error: authError,
  } = useAuth();

  const handleMicrosoftSignIn = async () => {
    try {
      await signInWithMicrosoft();
    } catch (err) {
      console.error("Erro ao fazer login:", err);
    }
  };

  // Loading State
  if (loading) {
    return (
      <div className={getContainerClasses()}>
        <div className="text-center flex flex-col items-center justify-center space-y-4">
          <LoadingSpinner message={LOGIN_MESSAGES.loading} size="lg" />
        </div>
      </div>
    );
  }

  // Redirect if authenticated
  if (user) {
    const from = new URLSearchParams(location.search).get("from");
    const target = from && from.startsWith("/") && !from.startsWith("//") && !from.startsWith("/login")
      ? from
      : "/";

    return <Navigate to={target} replace />;
  }

  return (
    <div className={clsx(getContainerClasses())}>
      <div className="max-w-md w-full space-y-8">
        {/* Card Container */}
        <div className={getCardClasses()}>
          {/* Header */}
          <div className="text-center">
            <Logo className="mx-auto h-24 w-auto filter drop-shadow-sm" />
            <p className="mt-3 text-base text-raro-gray-600 font-montserrat">
              {LOGIN_MESSAGES.subtitle}
            </p>
          </div>

          {/* Login Form */}
          <div className="mt-8 space-y-6">
            <Button
              variant="secondary"
              size="lg"
              onClick={handleMicrosoftSignIn}
              disabled={loading}
              className="w-full"
              leftIcon={
                <svg
                  className="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d={MICROSOFT_ICON_PATH} />
                </svg>
              }
            >
              {LOGIN_MESSAGES.signInMicrosoftButton}
            </Button>

            {/* Error Message */}
            {authError && (
              <Alert
                variant="error"
                title="Erro no login"
                description={authError}
                className="animate-slide-up"
              />
            )}
          </div>

          {/* Footer */}
          <div className="mt-8 text-center">
            <p className="text-xs text-raro-gray-500 font-montserrat">
              {LOGIN_MESSAGES.footer}
            </p>
          </div>
        </div>
      </div>
    </div>

  );
}
